import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
    font-family: sans-serif;
}

:root{
    --primary-color: #191923;
    --secundary-color: #FFD700;
    --white-color: #FFFFFF;
    --gray-1: #20202a;
    --gray-2: #25253297;
    --text-color: #7a7a7a;
    --divider-color: #8c8c8e;
    --gray-3: #2d2d3a;
}

#root{
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 15px;
    padding-left: 5%;
    background-color: var(--primary-color);
    min-height: 100vh;
    color: 	var(--white-color);
}

a{
    text-decoration: none;
}

button{
    cursor: pointer;
}

ul{
    list-style: none;
}

@media (max-width: 1250px){
   #root{
    padding-left: 1%;
   }
} 
`